var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"buy_customer",staticClass:"chartheight"})
}
var staticRenderFns = []

export { render, staticRenderFns }